import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import useStyles from './index.style';

const PageSectionAvios = ({
  title,
  description,
  textFragment,
  textFragment1,
  textFragment2,
  children,
  className,
}) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.rootPageSection, className)}>
      <Typography component="h1">{title}</Typography>
      <Typography component="p" paragraph>
        {description}
        <span>{textFragment}</span>
        <span>{textFragment1}</span>
        <span>{textFragment2}</span>
      </Typography>
      {children}
    </Box>
  );
};

export default PageSectionAvios;
